"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const api_1 = require("~/store/api");
const utils_1 = require("~/utils/utils");
const widgets_json_1 = __importDefault(require("~/locales/en/widgets.json"));
const events_1 = require("~/utils/events");
const actions_1 = require("~/store/widgets/content/defaultFasteners/actions");
const actions_2 = require("~/store/widgets/content/bom/actions");
const consts_1 = require("~/store/widgets/content/bom/consts");
const actions_3 = require("./actions");
const consts_2 = require("./consts");
function* fetchItemProperties({ payload }) {
    try {
        const response = yield (0, effects_1.call)(api_1.getFasteners, payload);
        yield (0, effects_1.put)((0, actions_3.requestRecommendedFastenersSuccess)(response));
    }
    catch (error) {
        yield (0, effects_1.put)((0, actions_3.requestRecommendedFastenersFail)((0, utils_1.errorify)(error)));
    }
}
function* fetchUpdateItemProject({ payload }) {
    var _a;
    const projectId = (_a = payload.createItems[0]) === null || _a === void 0 ? void 0 : _a.projectId;
    try {
        if (projectId) {
            yield (0, effects_1.put)((0, actions_2.setBOMFeedback)({ projectId, actionType: consts_1.REQUEST_SOCKET_UPDATE_FASTENERS_TO_BOM }));
        }
        const response = yield (0, effects_1.call)(api_1.updateFasteners, payload);
        if (payload.updateAll && response.amount) {
            const message = `${widgets_json_1.default.recommended['fasteners-have-been-changed-in']} ${response.amount} ${response.amount > 1 ? widgets_json_1.default.recommended.connections : widgets_json_1.default.recommended.connection}`;
            yield (0, effects_1.call)(events_1.showNotification, {
                message,
                type: 'success',
            });
        }
        if (response.fastenersExistence) {
            yield (0, effects_1.put)((0, actions_1.requestFastenersExistenceSuccess)(response.fastenersExistence));
        }
        yield (0, effects_1.put)((0, actions_3.requestUpdateItemProjectSuccess)(''));
    }
    catch (error) {
        if (projectId) {
            yield (0, effects_1.put)((0, actions_2.setBOMFeedback)({ projectId, failed: true }));
        }
        yield (0, effects_1.put)((0, actions_3.requestUpdateItemProjectFail)((0, utils_1.errorify)(error)));
    }
}
function* fetchDeleteItemProject({ payload }) {
    try {
        const response = yield (0, effects_1.call)(api_1.deleteFasteners, payload);
        if (payload.deleteAll && response.amount) {
            const message = `${widgets_json_1.default.recommended['fasteners-have-been-changed-from']} ${response.amount} ${response.amount > 1 ? widgets_json_1.default.recommended.connections : widgets_json_1.default.recommended.connection}`;
            yield (0, effects_1.call)(events_1.showNotification, {
                message,
                type: 'success',
            });
        }
        yield (0, effects_1.put)((0, actions_3.requestDeleteItemProjectSuccess)(''));
    }
    catch (error) {
        yield (0, effects_1.put)((0, actions_3.requestDeleteItemProjectFail)((0, utils_1.errorify)(error)));
    }
}
function* rootSaga() {
    yield (0, effects_1.all)([(0, effects_1.takeLatest)(consts_2.REQUEST_RECOMMENDED_FASTENERS, fetchItemProperties)]);
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(consts_2.REQUEST_UPDATE_RECOMMENDED_FASTENERS, fetchUpdateItemProject),
        (0, effects_1.takeLatest)(consts_2.REQUEST_DELETE_RECOMMENDED_FASTENERS, fetchDeleteItemProject),
    ]);
}
exports.default = rootSaga;
